import {userHovercardPath} from '@github-ui/paths'
import {Link} from '@primer/react'

type AssigneeProps = {
  assigneeLogin: string
}

export function Assignee({assigneeLogin}: AssigneeProps): JSX.Element {
  return (
    <Link
      data-hovercard-url={userHovercardPath({owner: assigneeLogin})}
      href={`/${assigneeLogin}`}
      sx={{
        color: 'fg.default',
      }}
      inline
    >
      {assigneeLogin}
    </Link>
  )
}

try{ Assignee.displayName ||= 'Assignee' } catch {}